import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Input,
  DestroyRef,
  inject,
  signal,
} from "@angular/core";
//import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatSort } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router, RouterLinkWithHref } from "@angular/router";
import {
  MatDialogModule,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MsalService } from "@azure/msal-angular";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import dayjs from "dayjs";

// Services
import { StoreUserService } from '@app/core/state/store-user.service';
import { ListSectionGroupsService } from "../../../data/section-group/list-section-groups.service";
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";
import { SystemAdminNavComponent } from "../system-admin-nav/system-admin-nav.component";
import { GetParameterService } from "../../../data/record/get-parameter.service";
import { UserDataTemplateListComponent } from "../user-data-template-list/user-data-template-list.component";
import { TableSkeletonComponent } from "../../../shared/skeleton";

// For Dialog view
import {
  SectionGroupDetailsComponent,
  SectionGroupDocument,
} from "../section-group-details/section-group-details.component";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { SECTION_GROUP_LIST_I18N } from "./section-group-list.i18n";

@Component({
  selector: "app-section-group-list",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./section-group-list.component.html",
  styleUrls: ["./section-group-list.component.scss"],
  imports: [...SHARED_IMPORTS, TableSkeletonComponent, PageHeaderComponent],
})
export class SectionGroupListComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = SECTION_GROUP_LIST_I18N;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("menuTrigger") menuTrigger: MatMenuTrigger;
  @ViewChild("searchInput") searchInput: ElementRef<HTMLInputElement>;

  loginUserId = "";
  filter = ""; //table filtering
  readonly searchExpanded = signal(false);

  selectedSectionGroup: any;
  currentUrl = "";
  isLoading = signal(true);

  userDataTemplates = [];

  sectionGroups: SectionGroupDocument[] = [];
  hasSectionGroupCreate;
  hasAllSectionGroupManagement;
  hasDistributorAgent;

  displayedColumns = ["sectionName", "address", "admins"];

  accountStatus: { [key: string]: string } = {
    OPEN: SECTION_GROUP_LIST_I18N.status.active,
    CLOSE: SECTION_GROUP_LIST_I18N.status.inactive,
  };

  dataSource: MatTableDataSource<SectionGroupDocument>;

  constructor(
    public storeUser: StoreUserService,
    private listSectionGroupsService: ListSectionGroupsService,
    private route: ActivatedRoute,
    private router: Router,
    private msalService: MsalService,
    public dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    private common: DatabaseCacheService,
    private saNav: SystemAdminNavComponent,
    private getParameterService: GetParameterService,
    private userDataTemplateListComponent: UserDataTemplateListComponent,
  ) {
    let user = this.msalService.instance.getActiveAccount();
    this.loginUserId = user.idTokenClaims["sub"];

    // カスタムSVG iconの呼び出し
    this.iconRegistry.addSvgIcon(
      "icon_staff", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_staff.svg",
      ), //必ずサニタイザーを利用して取得する。
    );

    this.iconRegistry.addSvgIcon(
      "icon_setting", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_setting.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-close", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-close.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-open", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-open.svg",
      ),
    );
  }

  ngOnInit() {
    this.getUserDataTemplates();
    this.listSectionGroups();

    this.hasSectionGroupCreate = this.common.hasSectionGroupCreate();
    this.hasDistributorAgent = this.common.hasAnyDistributorAgentRole();
    // section
    this.selectedSectionGroup = this.common.getSelectedSectionGroup();
    this.common.parametersUpdated.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((noData) => {
      // Sectionに関わるデータの読み込み
      this.selectedSectionGroup = this.common.getSelectedSectionGroup();
    });

    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.hasSectionGroupCreate = this.common.hasSectionGroupCreate();
      this.hasAllSectionGroupManagement =
        this.common.hasAllSectionGroupManagement();
    });
  }

  ngAfterViewInit(): void {}

  applyFilter(event?: Event) {
    if (event) {
      this.filter = (event.target as HTMLInputElement).value;
    }
    const filterValue = this.filter.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  // M3 Expandable Search methods
  expandSearch(): void {
    this.searchExpanded.set(true);
    setTimeout(() => {
      this.searchInput?.nativeElement?.focus();
    }, 50);
  }

  collapseSearch(): void {
    if (!this.filter.trim()) {
      this.searchExpanded.set(false);
    }
  }

  onSearchBlur(): void {
    this.collapseSearch();
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.filter = "";
    this.applyFilter();
  }

  refreshData(): void {
    this.listSectionGroups();
  }

  listSectionGroups() {

    // 通常は自分が管理者権限を持っている SectionGroupだけをリストする。
    // ユーザが ALL_SECTION_GROUP_MANAGEMENT 権限を持っている場合は、listAdministeredSectionGroups()は全ての SectionGroup を返す。
    let listFunc = () => this.listSectionGroupsService.listAdministeredSectionGroups();

    this.isLoading.set(true);

    listFunc().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res) => {

        var resArray = res as Array<any>;

        this.sectionGroups = [];
        for (let i = 0; i < resArray.length; i++) {
          var sectionGroup = resArray[i];

          sectionGroup.settings.userDataAttributes = JSON.stringify(sectionGroup.settings.userDataAttributes);
          this.sectionGroups.push(sectionGroup);
        }
        this.dataSource = new MatTableDataSource(this.sectionGroups);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.isLoading.set(false);
      },
      (error) => {
        this.isLoading.set(false);
      },
    );
  }

  getUserDataTemplates() {
    this.getParameterService
      .getParameter(this.userDataTemplateListComponent.parameterName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.userDataTemplates = (res as any).parameterValue;
        },
        (error) => {
          // Error handling
        },
      );
  }

  openCreateSectionGroupDialog() {
    this.openSectionGroupDetailDialog(null);
  }

  openSectionGroupDetailDialog(sectionGroupData) {

    const dialogRef = this.dialog.open(SectionGroupDetailsComponent, {
      width: "740px",
      disableClose: false,
      data: {
        title: this.i18n.dialog.confirmTitle,
        message: this.i18n.dialog.confirmMessage,
        sectionGroupData: sectionGroupData,
        userDataTemplates: this.userDataTemplates,
      },
    });
    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (result) => {
      if (result?.needRefresh) {
        await this.common.refreshAllData();
        this.listSectionGroups();
      }
    });
  }
}
